import { BrowserAgent } from '@newrelic/browser-agent/loaders/browser-agent'
// Remaining import statements

// Populate using values from NerdGraph
const options = {
    init: {
        distributed_tracing: { enabled: true },
        performance: { capture_measures: true },
        browser_consent_mode: { enabled: false },
        privacy: { cookies_enabled: true },
        ajax: { deny_list: ["bam.nr-data.net"] }
    },
    loader_config: {
        accountID: "7354964",
        trustKey: "7354964",
        agentID: "601611442",
        licenseKey: "NRBR-755e4b6fdb9ac53dc04",
        applicationID: "601611442"
    },
    info: {
        beacon: "bam.nr-data.net",
        errorBeacon: "bam.nr-data.net",
        licenseKey: "NRBR-755e4b6fdb9ac53dc04",
        applicationID: "601611442",
        sa: 1
    }
};

// The agent loader code executes immediately on instantiation.
const nrba = new BrowserAgent(options)

// Remaining code

import * as ReactDOM from "react-dom/client";
import WebApp from "./react/webApp";

ReactDOM.createRoot(document.getElementById('webApp')).render(WebApp());
